import { IntegrationsClient } from './queryClient';
import type { Redtail } from './types';

export type { Redtail } from './types';

// Query key factory for consistent key patterns across resources
export const queryKeys = {
  redtail: {
    all: ['redtail'] as const,
    resource: (resource: string) => [...queryKeys.redtail.all, resource] as const,
    lists: (resource: string) => [...queryKeys.redtail.resource(resource), 'list'] as const,
    list: (resource: string, params?: Record<string, unknown>) =>
      [...queryKeys.redtail.lists(resource), params] as const,
    details: (resource: string) => [...queryKeys.redtail.resource(resource), 'detail'] as const,
    detail: (resource: string, id: string) =>
      [...queryKeys.redtail.details(resource), id] as const,
  },
};

export const redtailApi = {
  auth: {
    login: (data: Redtail.AuthRequest) =>
      IntegrationsClient.post<Redtail.User>('/redtail/authenticate', data),

    status: () =>
      IntegrationsClient.get<Redtail.User | null>('/redtail/status'),

    deactivate: () =>
      IntegrationsClient.post<Redtail.User>('/redtail/user/deactivate'),
  },

  contacts: {
    list: (params?: Redtail.ContactListParams) =>
      IntegrationsClient.get<Redtail.ContactListResponse>('/redtail/contacts', params),

    get: (contactId: string) =>
      IntegrationsClient.get<Redtail.Contact>(`/redtail/contacts/${contactId}`),

    update: (contactId: string, data: Partial<Redtail.Contact>) =>
      IntegrationsClient.post<{ contact: Redtail.Contact }>(`/redtail/contacts/${contactId}`, data),

    import: (data: Redtail.ImportContactsRequest) =>
      IntegrationsClient.post<string[]>('/redtail/contacts/import', data),

    link: ({ contactId, clientId }: Redtail.LinkContactRequest) =>
      IntegrationsClient.post<Redtail.LinkedContact>(`/redtail/contacts/${contactId}/link`, { clientId }),

    unlink: (contactId: string) =>
      IntegrationsClient.delete<{ success: boolean }>(`/redtail/contacts/${contactId}/unlink`),
  },
};
